import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import * as Constants from "../../consts/Constants.js";
import redMarker from "../../assets/images/markers/redMarker.png";
import L from "leaflet";
import { msToTime } from "../../utils/DateUtils";
import ContactExpanded from "./ContactExpanded";
import { Point } from "leaflet";

export default function MapVisitUser(props) {
  console.log(props);
  const [center, setCenter] = React.useState({
    lat: Constants.LATITUD_AYACUCHO,
    lng: Constants.LONGITUD_AYACUCHO,
  });

  const [map, setMap] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [contactSelected, setContactSelected] = React.useState(null);

  const getMarkers = (data) => {
    console.log(data);
    return data.map((contact, index) =>
      contact.visita.center !== undefined ? (
        <Marker
          key={index}
          position={[
            contact.visita.center.latitude,
            contact.visita.center.longitude,
          ]}
          icon={
            new L.Icon({
              iconUrl: redMarker,
              iconSize: [32, 45],
            })
          }
          eventHandlers={{
            click: (e) => {
              setOpen(true);
              setContactSelected(contact);
            },
          }}
        >
          <Popup>
            {contactSelected !== null ? (
              <div>
                Contacto con {contactSelected.usuario.nombre}{" "}
                {contactSelected.usuario.apellido} <br />
                Tiempo de contacto: {msToTime(contactSelected.solapamiento)}
              </div>
            ) : null}
          </Popup>
        </Marker>
      ) : null
    );
  };

  return (
    <div
      style={{
        width: "55%",
      }}
    >
      <MapContainer
        style={{
          height: "450px",
          margin: "20px",
          zIndex: 399,
        }}
        center={center}
        zoom={15}
        scrollWheelZoom={true}
        whenCreated={setMap}
      >
        {props ? getMarkers(props.data) : null}
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </div>
  );
}
